import instanceQuery from 'graphql/queries/system/SystemConfigQuery.graphql';
import defaultQuery from 'graphql/queries/system/SystemConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/system/SystemConfigMutation.graphql';
import fragment from 'graphql/fragments/system/SystemConfigFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const SystemConfig = {
  type: 'SystemConfig',
  title: 'System Configuration',
  formTitle: 'System Configuration',
  formUrl: '/System/SystemConfig/',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  operations: ALLOW_EDIT | ALLOW_VIEW,
  screenReference: 'SYSTEM_CONFIG',
};

export default SystemConfig;
